import React from 'react';
import moment from 'moment';
import './SharePopover.styl';
import formatDate from 'utils/formatDate';
import {List} from 'immutable';
import {associateBy} from 'utils/associateBy';

// FE equivalent of io.execvision.model.Persona#nameOrEmail
function nameOrEmail(user) {
  if (!user.firstName && !user.lastName) {
    return user.email;
  } else if (!user.firstName) {
    return user.lastName;
  } else if (!user.lastName) {
    return user.firstName;
  } else {
    return `${user.firstName} ${user.lastName}`;
  }
}

const ShareRow = ({item}) => {
  // This popover serves both 'call_i_shared' and 'call_shared', it can't be split in two because otherwise there will
  // be two share icons on the action icons bar, so we just render differently for each
  const isIShared = item.context.type === 'call_i_shared';
  const shareTargets = isIShared
    ? item.context.shareUsers.map(user => nameOrEmail(user)).concat(item.context.shareEmails)
    : List([item.context.sharerName]);

  return (
    <tr>
      <td className="share-targets">
        {shareTargets.map((t, i) => (
          <span key={i}>{t}</span>
        ))}
      </td>
      <td>{formatDate(moment(item.timestamp))}</td>
      <td className="comments">{item.context.reason}</td>
    </tr>
  );
};

export default class SharePopover extends React.Component {
  render() {
    const {items} = this.props;

    if (items.size === 0) return;
    const uniqueItems = associateBy(items, i => i.id).toList();

    return (
      <div>
        <h2 className="popover-header">Shared with</h2>
        <table className="share-history">
          <thead>
            <tr>
              <td>User(s)</td>
              <td>Date</td>
              <td>Comments</td>
            </tr>
          </thead>
          <tbody>
            {uniqueItems
              .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
              .map((i, j) => (
                <ShareRow item={i} key={j} />
              ))}
          </tbody>
        </table>
      </div>
    );
  }
}
